const map = {
	"./about-content/about-content.js": "./src/common.blocks/about-content/about-content.js",
	"./admin-login/admin-articles-content.js": "./src/common.blocks/admin-login/admin-articles-content.js",
	"./admin-login/admin-categories-content.js": "./src/common.blocks/admin-login/admin-categories-content.js",
	"./admin-login/admin-contacts-content.js": "./src/common.blocks/admin-login/admin-contacts-content.js",
	"./admin-login/admin-content.js": "./src/common.blocks/admin-login/admin-content.js",
	"./admin-login/admin-docs-content.js": "./src/common.blocks/admin-login/admin-docs-content.js",
	"./admin-login/admin-faq-content.js": "./src/common.blocks/admin-login/admin-faq-content.js",
	"./admin-login/admin-feedback-content.js": "./src/common.blocks/admin-login/admin-feedback-content.js",
	"./admin-login/admin-home-content.js": "./src/common.blocks/admin-login/admin-home-content.js",
	"./admin-login/admin-login.js": "./src/common.blocks/admin-login/admin-login.js",
	"./admin-login/admin-login.scss": "./src/common.blocks/admin-login/admin-login.scss",
	"./admin-login/admin-map-content.js": "./src/common.blocks/admin-login/admin-map-content.js",
	"./admin-login/admin-portfolio-content.js": "./src/common.blocks/admin-login/admin-portfolio-content.js",
	"./admin-login/admin-reviews-content.js": "./src/common.blocks/admin-login/admin-reviews-content.js",
	"./admin-login/admin-services-content.js": "./src/common.blocks/admin-login/admin-services-content.js",
	"./advantage-preview/advantage-preview.scss": "./src/common.blocks/advantage-preview/advantage-preview.scss",
	"./advantage-section/advantage-section.scss": "./src/common.blocks/advantage-section/advantage-section.scss",
	"./advertising-section/advertising-section.scss": "./src/common.blocks/advertising-section/advertising-section.scss",
	"./api/api.js": "./src/common.blocks/api/api.js",
	"./articles-content/articles-content.js": "./src/common.blocks/articles-content/articles-content.js",
	"./articles-section/articles-section.scss": "./src/common.blocks/articles-section/articles-section.scss",
	"./articles/articles.scss": "./src/common.blocks/articles/articles.scss",
	"./big-slider/big-slider.scss": "./src/common.blocks/big-slider/big-slider.scss",
	"./blog/blog.scss": "./src/common.blocks/blog/blog.scss",
	"./burger-menu/burger-menu.scss": "./src/common.blocks/burger-menu/burger-menu.scss",
	"./categories-content/categories-content.js": "./src/common.blocks/categories-content/categories-content.js",
	"./clients-section/clients-section.scss": "./src/common.blocks/clients-section/clients-section.scss",
	"./contacts-content/contacts-content.js": "./src/common.blocks/contacts-content/contacts-content.js",
	"./contacts-section/contacts-section.scss": "./src/common.blocks/contacts-section/contacts-section.scss",
	"./docs-content/docs-content.js": "./src/common.blocks/docs-content/docs-content.js",
	"./employee-preview/employee-preview.scss": "./src/common.blocks/employee-preview/employee-preview.scss",
	"./employees-section/employees-section.scss": "./src/common.blocks/employees-section/employees-section.scss",
	"./error-page/error-page.scss": "./src/common.blocks/error-page/error-page.scss",
	"./example-preview/example-preview.scss": "./src/common.blocks/example-preview/example-preview.scss",
	"./example-section/example-section.scss": "./src/common.blocks/example-section/example-section.scss",
	"./faq-content/faq-content.js": "./src/common.blocks/faq-content/faq-content.js",
	"./faq-section/faq-section.scss": "./src/common.blocks/faq-section/faq-section.scss",
	"./feedback-content/feedback-content.js": "./src/common.blocks/feedback-content/feedback-content.js",
	"./feedback-section/feedback-section.js": "./src/common.blocks/feedback-section/feedback-section.js",
	"./feedback-section/feedback-section.scss": "./src/common.blocks/feedback-section/feedback-section.scss",
	"./footer/footer.scss": "./src/common.blocks/footer/footer.scss",
	"./header/header.scss": "./src/common.blocks/header/header.scss",
	"./hero-section/hero-section.scss": "./src/common.blocks/hero-section/hero-section.scss",
	"./history-block/history-block.scss": "./src/common.blocks/history-block/history-block.scss",
	"./history-section/history-section.scss": "./src/common.blocks/history-section/history-section.scss",
	"./home-content/home-content.js": "./src/common.blocks/home-content/home-content.js",
	"./index.js": "./src/common.blocks/index.js",
	"./info-preview/info-preview.scss": "./src/common.blocks/info-preview/info-preview.scss",
	"./introduction/introduction.scss": "./src/common.blocks/introduction/introduction.scss",
	"./location-section/location-section.js": "./src/common.blocks/location-section/location-section.js",
	"./location-section/location-section.scss": "./src/common.blocks/location-section/location-section.scss",
	"./map-content/map-content.js": "./src/common.blocks/map-content/map-content.js",
	"./map/map.js": "./src/common.blocks/map/map.js",
	"./map/map.scss": "./src/common.blocks/map/map.scss",
	"./nav/nav.scss": "./src/common.blocks/nav/nav.scss",
	"./policy-page/policy-page.scss": "./src/common.blocks/policy-page/policy-page.scss",
	"./portfolio-content/portfolio-content.js": "./src/common.blocks/portfolio-content/portfolio-content.js",
	"./portfolio-section/portfolio-section.scss": "./src/common.blocks/portfolio-section/portfolio-section.scss",
	"./portfolio/portfolio.scss": "./src/common.blocks/portfolio/portfolio.scss",
	"./review-preview/review-preview.js": "./src/common.blocks/review-preview/review-preview.js",
	"./review-preview/review-preview.scss": "./src/common.blocks/review-preview/review-preview.scss",
	"./reviews-content/reviews-content.js": "./src/common.blocks/reviews-content/reviews-content.js",
	"./reviews-section/reviews-section.scss": "./src/common.blocks/reviews-section/reviews-section.scss",
	"./search-block/search-block.js": "./src/common.blocks/search-block/search-block.js",
	"./search-block/search-block.scss": "./src/common.blocks/search-block/search-block.scss",
	"./search-page/search-page.scss": "./src/common.blocks/search-page/search-page.scss",
	"./service-overview/service-overview.scss": "./src/common.blocks/service-overview/service-overview.scss",
	"./service-preview/service-preview.scss": "./src/common.blocks/service-preview/service-preview.scss",
	"./services-content/services-content.js": "./src/common.blocks/services-content/services-content.js",
	"./services-section/services-section.scss": "./src/common.blocks/services-section/services-section.scss",
	"./services/services.scss": "./src/common.blocks/services/services.scss",
	"./slide-row/slide-row.scss": "./src/common.blocks/slide-row/slide-row.scss",
	"./social/social.scss": "./src/common.blocks/social/social.scss",
	"./stages-section/stages-section.scss": "./src/common.blocks/stages-section/stages-section.scss",
	"./tags/tags.scss": "./src/common.blocks/tags/tags.scss",
	"./ui/accordion/accordion.js": "./src/common.blocks/ui/accordion/accordion.js",
	"./ui/anchors/anchors.js": "./src/common.blocks/ui/anchors/anchors.js",
	"./ui/breadcrumbs/breadcrumbs.js": "./src/common.blocks/ui/breadcrumbs/breadcrumbs.js",
	"./ui/breadcrumbs/breadcrumbs.scss": "./src/common.blocks/ui/breadcrumbs/breadcrumbs.scss",
	"./ui/btn/btn.scss": "./src/common.blocks/ui/btn/btn.scss",
	"./ui/burger/burger.js": "./src/common.blocks/ui/burger/burger.js",
	"./ui/burger/burger.scss": "./src/common.blocks/ui/burger/burger.scss",
	"./ui/custom-count/custom-count.scss": "./src/common.blocks/ui/custom-count/custom-count.scss",
	"./ui/form/form.scss": "./src/common.blocks/ui/form/form.scss",
	"./ui/glightbox/glightbox.js": "./src/common.blocks/ui/glightbox/glightbox.js",
	"./ui/glightbox/glightbox.scss": "./src/common.blocks/ui/glightbox/glightbox.scss",
	"./ui/marquee/marquee.js": "./src/common.blocks/ui/marquee/marquee.js",
	"./ui/marquee/marquee.scss": "./src/common.blocks/ui/marquee/marquee.scss",
	"./ui/pagination/pagination.scss": "./src/common.blocks/ui/pagination/pagination.scss",
	"./ui/popup/popup-employee.scss": "./src/common.blocks/ui/popup/popup-employee.scss",
	"./ui/popup/popup-portfolio.scss": "./src/common.blocks/ui/popup/popup-portfolio.scss",
	"./ui/popup/popup.js": "./src/common.blocks/ui/popup/popup.js",
	"./ui/popup/popup.scss": "./src/common.blocks/ui/popup/popup.scss",
	"./ui/scroll-up/scroll-up.js": "./src/common.blocks/ui/scroll-up/scroll-up.js",
	"./ui/scroll-up/scroll-up.scss": "./src/common.blocks/ui/scroll-up/scroll-up.scss",
	"./ui/simplebar/simplebar.js": "./src/common.blocks/ui/simplebar/simplebar.js",
	"./ui/simplebar/simplebar.scss": "./src/common.blocks/ui/simplebar/simplebar.scss",
	"./ui/swiper/swiper.js": "./src/common.blocks/ui/swiper/swiper.js",
	"./user-content/user-content.scss": "./src/common.blocks/user-content/user-content.scss",
	"./utils/sanitize.js": "./src/common.blocks/utils/sanitize.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common.blocks sync recursive \\.(js%7Cscss)$";